<template>
    <div>
        <form class="ui form" style="padding:10px;" id="noteform" method="post">
            <input type="hidden" name="items" id="items" v-bind:value="items">
            <input v-if="!new_note" type="hidden" name="uuid" v-bind:value="note_id">
            <textarea name="note" id="note">{{note}}</textarea>
            <div style="margin-bottom: 20px;text-align: right;">
                <i class="large times red icon" v-on:click="cancel()" style="cursor:pointer"></i>&nbsp;&nbsp;<i class="large check blue icon" style="cursor:pointer" v-on:click="submit()"></i></button>
            </div>
            <div class="ui error message"></div>
        </form>
    </div>

</template>


<script>
    export default {
        props: ['new_note', 'note_id', 'items', 'related_items'],
        data() {
            return {
                note: ""
            }
        },
        mounted() {
            this.note="";
            var myThis=this;
            setTimeout(function(){
                myThis.setForm()
                },100);
            if (!this.new_note && this.note_id != "") {
                this.loadData();
            }
        },
        methods: {
            setForm: function() {
                var myThis = this;
                var fields = {
                    note: 'empty'
                }

                $('#noteform').form({
                    on: 'blur',
                    fields: fields,
                    onSuccess: function(event, fields) {
                        event.preventDefault();
                        var formArray = $('form').serializeArray();
                        var postBody = {};
                        for (var i in formArray) {
                            postBody[formArray[i].name] = formArray[i].value;
                        }
                        if (myThis.new_note) { //create
                            axios.post('/api/note', postBody)
                                .then(function(response) {
                                    console.log(response.status);
                                    myThis.$emit('submitNote', response.status);
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    myThis.$emit('submitNote', response.status);
                                });
                        }
                        else { //update
                            axios.put('/api/note', postBody)
                                .then(function(response) {
                                    console.log(response);
                                    myThis.$emit('submitNote', response.status);
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    myThis.$emit('submitNote', response.status);
                                });
                        }
                    }
                });
            },
            submit: function() {
                // alert("submit");
                $('#noteform').form('submit');
                $('#note').val("");
            },

            loadData: function() {
                axios
                    .get('/api/note/' + this.note_id)
                    .then(response => {
                        this.note = response.data.note;
                    });
            },

            cancel: function() {
                this.$emit('cancelNote');
            },
        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TheNoteFormV2.vue